<script setup>
  import { useRouter } from 'vue-router'

  const router = useRouter();

  const backTo = () => {
    router.go(-1)
  }
</script>

<template lang="pug">
section.bg-white(class='dark:bg-gray-900')
  .py-8.px-4.mx-auto.max-w-screen-xl(class='lg:py-16 lg:px-6')
    .mx-auto.max-w-screen-sm.text-center
      h1.mb-4.text-7xl.tracking-tight.font-extrabold.text-primary-600(class='lg:text-9xl dark:text-primary-500') 500
      p.mb-4.text-3xl.tracking-tight.font-bold.text-gray-900(class='md:text-4xl dark:text-white') Server Error.
      p.mb-4.text-lg.font-light.text-gray-500(class='dark:text-gray-400') We are sorry but our server encountered an internal error..
      Button.inline-flex.text-white.bg-primary-600.font-medium.rounded-lg.text-sm.px-5.text-center.my-4(@click="backTo" class='hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 py-2.5 dark:focus:ring-primary-900') Back to the page
</template>